import { render, staticRenderFns } from "./bottom2.vue?vue&type=template&id=d91a2b20&"
import script from "./bottom2.vue?vue&type=script&lang=js&"
export * from "./bottom2.vue?vue&type=script&lang=js&"
import style0 from "./bottom2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports